<template>
    <v-form @submit.prevent="enterKeySubmit">
        <v-text-field
            v-model="email"
            label="Email"
            prepend-inner-icon="mdi-email-outline"
            autocomplete="username"
            outlined
            dense
            autofocus
        />
        <v-text-field
            v-model="password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            label="Password"
            prepend-inner-icon="mdi-lock-outline"
            autocomplete="current-password"
            outlined
            dense
            @click:append="show = !show"
        />
        <v-btn
            type="submit"
            class="white--text mt-2"
            color="black"
            block
            large
            depressed
            :disabled="shouldDisableSubmit()"
            :loading="dialog"
        >
            Sign in
        </v-btn>
    </v-form>
</template>

<script>
    import store from '@/store'
    import userService from '@/services/user'

    export default {
        props: {
        },
        data() {
            return {
                show: false,
                dialog: false,
                email: '',
                password: '',
                message: ''
            }
        },
        methods: {
            enterKeySubmit() {
                if (!this.shouldDisableSubmit()) {
                    this.submit()
                }
            },
            shouldDisableSubmit() {
                if (!this.password || !this.email) {
                    return true
                }
                return false
            },
            submit() {
                this.dialog = true
                userService.login({
                    username: this.email,
                    password: this.password
                }).then(resp => {
                    this.dialog = false
                    store.dispatch('login', [resp]).then(() => this.$router.push('/'))
                }).catch(error => {
                    this.error = error.response.data
                    this.message = error.response.data.message
                    this.$emit('setAlert', this.message, 'error')
                    this.dialog = false
                })
            }
        }
    }
</script>

<style scoped>
</style>
